import * as React from "react";
import styles = require("./style.less");
import { Tooltip as ToolTip } from "@octopusdeploy/design-system-components";
import type { TooltipContent as ToolTipContent } from "@octopusdeploy/design-system-components";
import cn from "classnames";
import { secondaryText } from "colors";

export enum Icon {
    UseDefaultImage,
    EnterFullScreen,
    ExitFullScreen,
    Refresh,
    Add,
    Search,
    Show,
    Hide,
    Edit,
    Remove,
    Cancel,
    ArrowDown,
    Upload,
    ArrowUp
}

interface IconButtonProps {
    icon?: Icon | string;
    customIcon?: JSX.Element;
    toolTipContent?: ToolTipContent;
    disabled?: boolean;
    tabIndex?: number;
    onClick: (event: any) => void;
    buttonRef?: any; // kept for call-site compatibility; no longer forwarded
}

const IconButton: React.FC<IconButtonProps> = props => {
    if (props.icon != null) {
        if (typeof props.icon === "string") {
            return iconButton(<img className={styles.imageIcon} src={props.icon} alt="" />, props);
        }

        switch (props.icon) {
            case Icon.EnterFullScreen:  return faIconButton("fa-expand",    props);
            case Icon.ExitFullScreen:   return faIconButton("fa-compress",  props);
            case Icon.UseDefaultImage:  return faIconButton("fa-picture-o", props);
            case Icon.Refresh:          return faIconButton("fa-refresh",   props);
            case Icon.Add:              return faIconButton("fa-plus",      props);
            case Icon.Search:           return faIconButton("fa-search",    props);
            case Icon.Show:             return faIconButton("fa-eye",       props);
            case Icon.Hide:             return faIconButton("fa-eye-slash", props);
            case Icon.Edit:             return faIconButton("fa-pencil",    props);
            case Icon.Cancel:           return faIconButton("fa-times",     props);
            case Icon.Remove:           return faIconButton("fa-trash-o",   props);
            case Icon.Upload:           return faIconButton("fa-upload",    props);
            case Icon.ArrowDown:        return faIconButton("fa-caret-down", props, secondaryText);
            case Icon.ArrowUp:          return faIconButton("fa-caret-up",   props, secondaryText);
        }
    }

    return iconButton(props.customIcon, props);
};

function faIconButton(iconClass: string, props: IconButtonProps, color?: string) {
    return iconButton(
        <em className={cn("fa", iconClass, styles.fontAwesomeIcon)} aria-hidden="true" style={color ? { color } : undefined} />,
        props
    );
}

function iconButton(label: JSX.Element | undefined, props: IconButtonProps) {
    const elem = (
        <button
            className={styles.materialUIIcon}
            disabled={props.disabled}
            tabIndex={props.tabIndex}
            onClick={props.onClick}
        >
            {label}
        </button>
    );

    if (!props.toolTipContent) {
        return elem;
    }

    return <ToolTip content={props.toolTipContent}>{elem}</ToolTip>;
}

IconButton.displayName = "IconButton";

export default IconButton;
